<script setup lang="ts">
import { computed } from 'vue'
import { useBloxRuntime } from '@bagelink/blox'
import { stubUnframeableEmbeds } from '@/utils/embedPreview'

/**
 * Renders editor / CMS HTML, with a designer-safe fallback for embeds.
 *
 * Inside the Blox designer (`/_blox_preview`) embeds that refuse framing
 * (`frame-ancestors` / `X-Frame-Options` — Neon donation forms, most SaaS
 * widgets, …) would paint the browser's broken-frame error. They are swapped
 * for a quiet placeholder instead; frameable providers (YouTube, Vimeo, Maps,
 * …) keep rendering. See `@/utils/embedPreview`.
 */
const props = defineProps<{
	html?: string
	/** Root element tag — keep semantic markup where the caller needs it. */
	tag?: string
}>()

const { isPreview } = useBloxRuntime()

const output = computed(() => {
	const html = props.html ?? ''
	return isPreview.value ? stubUnframeableEmbeds(html) : html
})
</script>

<template>
	<component :is="tag ?? 'div'" v-html="output" />
</template>
